<template>
    <el-select :multiple="multiple" :value="value"  collapse-tags :clearable="clearable" :value-key="type=='object'?'dicCode':''"  @visible-change="visiblechange"  @change="change" :size="size" :placeholder="placeholder" >
        <el-option
                v-for="item,index in list"
                :key="item.dicCode"
                :label="item.dicName"
                :value="type=='object'?item:item.dicCode">
        </el-option>
    </el-select>
</template>

<script>
    export default {
        name: "order-state",
        props:{
            size:String,
            placeholder:String,
            multiple:Boolean,
            value:[Array,Object,String],
            type:String,
            clearable:Boolean
        },
        model:{
            prop:'value'
        },
        data(){
            return{
                list:[],
            }
        },
        mounted(){
            this.getData();
        },
        watch:{
            value(newval,oldval){
                var code=this.type=='object'?newval.dicCode:newval;
                var list=this.list.filter((item)=>item.dicCode==code);
                //数据不存在时
                if(list.length==0){
                    this.$store.state.dicChange=true;
                    this.getData();
                }

            }
        },
        methods:{
            getData(){
                if(this.$root.getStorage('dic')){
                    this.list=this.$root.getStorage('dic').filter((item)=>item.dicType=='order_state');
                }else{
                    this.$store.state.dicChange=true;
                }
            },
            visiblechange(isshow){
                if(isshow){
                    this.getData();
                }
            },
            change(value){
                console.log(value)
                this.$emit('input',value)
            }
        }
    }
</script>

<style scoped>

</style>